<template>
  <a-popover
    :overlay-class-name="bem.b()"
    placement="bottomRight"
    :overlay-style="props.overlayStyle"
    :open="showSelectBox"
  >
    <template #content>
      <advanced-filtering-params
        v-model:value="filterValue"
        :filter-columns="props.filterColumns"
        :form-options="props.formOptions"
        @close="handleClose"
      />
    </template>
    <a-popover
      :overlay-class-name="bem.b()"
      trigger="hover"
      placement="bottomRight"
      :open="showValueBox"
      :overlay-style="props.overlayStyle"
      @open-change="handleHoverChange"
    >
      <template #content>
        <advanced-filtering-tags
          :value="filterValue"
          :filter-columns="props.filterColumns"
          @change="handleChange"
        />
      </template>
      <ll-button @click.stop="handleClickChange">
        <ll-icon icon-name="icon-a-shaixuan1x" style="margin-right: 10px" />
        <span>高级筛选</span>
      </ll-button>
    </a-popover>
  </a-popover>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

import { createNamespace } from '@ll-plus/utils'

import {
  advancedFilteringProps,
  advancedFilteringEmits
} from './advanced-filtering'

import { LlButton, LlIcon } from '@ll-plus/components'
import AdvancedFilteringParams from './components/advanced-filtering-params.vue'
import AdvancedFilteringTags from './components/advanced-filtering-tags.vue'

defineOptions({ name: 'LlAdvancedFiltering' })
const props = defineProps(advancedFilteringProps)
const emits = defineEmits(advancedFilteringEmits)
const bem = createNamespace('advanced-filtering')
const filterValue = ref<any>(props.value)
const showSelectBox = ref<boolean>(false)
const showValueBox = ref<boolean>(false)

const handleHoverChange = (visible: boolean) => {
  if (showSelectBox.value) return
  showValueBox.value = visible
}

const handleClickChange = () => {
  showSelectBox.value = !showSelectBox.value
  showValueBox.value = false
}

const handleClose = () => {
  showSelectBox.value = false
  showValueBox.value = false
}

const handleChange = val => {
  filterValue.value = val
}

watch(
  filterValue,
  n => {
    emits('update:value', n)
    emits('change', n)
  },
  {
    deep: true
  }
)
</script>
